import React, { useState } from 'react';

/**
 * GeneralPage component for Training module.
 * Displays general information or content for training.
 */
const MenuPage: React.FC = () => {
    const [selectedHelpPage, setSelectedHelpPage] = useState("shortcuts");

    function getContent(name: string): JSX.Element {
        switch (name) {
            case "shortcuts":
                return <Shortcuts />
            case "newProject":
                return <NewProject />
            case "deleteProject":
                return <DeleteProject />
            default:
                return <Shortcuts />
        }
    }

    return (
        <div className="flex flex-row w-full pt-4">
            <div className="flex flex-col min-w-[200px] mr-2">
                <ul className="text-center">
                    <li className={(selectedHelpPage == "shortcuts" ? "bg-table-subheader " : "bg-table-header ") + "rounded-tl-md p-2 bg-table-header hover:cursor-pointer "} onClick={() => setSelectedHelpPage("shortcuts")}>Keyboard Shortcuts</li>
                    <li className={(selectedHelpPage == "newProject" ? "bg-table-subheader " : "bg-table-header ") + "p-2 bg-table-header hover:cursor-pointer "} onClick={() => setSelectedHelpPage("newProject")}>Creating a Project</li>
                    <li className={(selectedHelpPage == "deleteProject" ? "bg-table-subheader " : "bg-table-header ") + "rounded-bl-md p-2 bg-table-header hover:cursor-pointer "} onClick={() => setSelectedHelpPage("deleteProject")}>Deleting a Project</li>
                </ul>
            </div>
            <div className="flex flex-col h-[800px] p-2 overflow-y-auto scrollbar">{getContent(selectedHelpPage)}</div>
        </div>
    );
};

export default MenuPage;

const NewProject: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Creating a Project</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/charter/Creating_new_project.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Create a new project via the project selection dropdown menu.
                    </p>
                    <br />
                    <p>
                        You will be redirected to the charter page. Lock the charter page for editing by clicking the page lock toggle in the top right corner.
                    </p>
                    <br />
                    <p>
                        When you edit a field, it will be saved automatically when you leave the field, which will be indicated with a message in the taskbar
                        at the bottom right corner of the screen.
                    </p>
                </div>
            </div>
        </>
    );
}

const DeleteProject: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Deleting a Project</h1>
            <div className="flex flex-row">
                <video width="960" height="720" controls>
                    <source src="/videos/help/general/Deleting_a_project.mp4" type="video/mp4" />
                </video>
                <div className="p-2">
                    <p>
                        Delete a project via the project selection dropdown menu.
                    </p>
                </div>
            </div>
        </>
    );
}

const Shortcuts: React.FC = () => {
    return (
        <>
            <h1 className="text-2xl font-bold mb-2">Keyboard Shortcuts</h1>
            <table className="table-auto border-collapse border border-slate-400">
                <thead>
                    <tr>
                        <th className="border border-slate-300 p-2">Shortcut</th>
                        <th className="border border-slate-300 p-2">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + B</td>
                        <td className="border border-slate-300 p-2">Hide / Show Sidebar</td>
                    </tr>
                    <tr>
                        <td className="border border-slate-300 p-2">Ctrl + J</td>
                        <td className="border border-slate-300 p-2">Open the 'Jump' menu to navigate quickly</td>
                    </tr>
                </tbody>
            </table>
        </>
    );
}